import { useContext } from 'react';
import { LocalStoreProviderContext } from './LocalStoreProvider.constants';

export const useLocalStore = <T extends Record<string, any>>(): T => {
  const value = useContext(LocalStoreProviderContext);

  if (value === null) {
    throw new Error('useLocalStore must be used within LocalStoreProviderContext');
  }

  return value;
};
